import { render, staticRenderFns } from "./common-city-town-taiwan.vue?vue&type=template&id=05eaf529&scoped=true"
import script from "./common-city-town-taiwan.vue?vue&type=script&lang=js"
export * from "./common-city-town-taiwan.vue?vue&type=script&lang=js"
import style0 from "./common-city-town-taiwan.vue?vue&type=style&index=0&id=05eaf529&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05eaf529",
  null
  
)

export default component.exports